import React, { useEffect, useState } from "react";
import { Coaches } from "../../Components/Front-End/CoachingTeam/Coaches";
import Banner from "../../Components/Front-End/Banner/Banner";
import BannerImg from "../../assets/Banners/coaching-team.jpg";
import { ClipLoader } from "react-spinners";

const CoachPage = () => {
    const [starSkateCoaches, setStarSkateCoaches] = useState([]);
    const [learnToSkateCoaches, setLearnToSkateCoaches] = useState([]);
    const [prePowerCoaches, setPrePowerCoaches] = useState([]);
    const [Admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCoaches = async () => {
            try {
                const response = await fetch("/api/coaches/GetCoachesPublic");
                if (!response.ok) throw new Error("Failed to fetch coaches");

                const data = await response.json();

                setStarSkateCoaches(data.filter(c => c.coachTypeId === 1));
                setLearnToSkateCoaches(data.filter(c => c.coachTypeId === 2));
                setPrePowerCoaches(data.filter(c => c.coachTypeId === 3));
                setAdmins(data.filter(c => c.coachTypeId === 4));

                // Delay for 1 second before showing content
                await new Promise(resolve => setTimeout(resolve, 1000));
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCoaches();
    }, []);

    return (
        <div>
            <Banner
                heading="Coaching Staff"
                description="Our coaching team is a dynamic part of the Federation Skating Club that molds and shapes the atmosphere on and off the ice. Their enthusiastic dedication to the skaters and our programs enables them to pass on knowledge and build the basic skills of all our skaters."
                buttons={[{ title: "Contact Us" }]}
                image={{
                    src: BannerImg,
                    alt: "Coach Image",
                }}
            />

            {loading ? (
                <div className="flex items-center justify-center h-64">
                    <ClipLoader color="#ef4444" size={60} />
                </div>
            ) : error ? (
                <p className="text-center text-red-600 mt-8">Error: {error}</p>
            ) : (
                <>

                    {Admins.length > 0 && (
                        <Coaches
                            tagline="Admins"
                            heading="Admin Team"
                            description="Meet our Admin Team"
                            teamMembers={Admins}
                        />
                    )}
                    
                    {starSkateCoaches.length > 0 && (
                        <Coaches
                            tagline="Coaches"
                            heading="StarSkate"
                            description="Meet our StarSkate coaches!"
                            teamMembers={starSkateCoaches}
                        />
                    )}

                    {learnToSkateCoaches.length > 0 && (
                        <Coaches
                            tagline="Coaches"
                            heading="Learn to Skate"
                            description="Meet our Learn to Skate coaches!"
                            teamMembers={learnToSkateCoaches}
                        />
                    )}

                    {prePowerCoaches.length > 0 && (
                        <Coaches
                            tagline="Coaches"
                            heading="Pre-Power"
                            description="Meet our Pre-Power coaches!"
                            teamMembers={prePowerCoaches}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default CoachPage;
